import { connect } from 'react-redux';
import loyaltyAction from '../../../../actions/loyalty';

const mapStateToProps = (state) => ({
  ...state.loyalty,
  loyaltyProgram: state.loyalty.selectedLoyaltyProgram,
  page:           state.page.selected,
});

const mapDispatchToProps = (dispatch) => ({
  updateLoyaltyCardAction: (data) => loyaltyAction.loyaltyProgramDataUpdate(dispatch, data),

  showSaveBtnAction: () => loyaltyAction.showLCSaveBtn(dispatch),
  hideSaveBtnAction: () => loyaltyAction.hideLCSaveBtn(dispatch),

  dispatchStartSavingLC:  () => loyaltyAction.startSavingLC(dispatch),
  dispatchFinishSavingLC: () => loyaltyAction.finishSavingLC(dispatch),

  enableSaveBtnAction:  () => loyaltyAction.enableSaveBtn(dispatch),
  disableSaveBtnAction: () => loyaltyAction.disableSaveBtn(dispatch),

  showAdvancedStatusBtn: () => loyaltyAction.showAdvancedStatusBtn(dispatch),
  hideAdvancedStatusBtn: () => loyaltyAction.hideAdvancedStatusBtn(dispatch),
});

const withLoyaltyConnect = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export default withLoyaltyConnect;
